import BaseComponent from '@/components/base';

export default class ResultsBanner extends BaseComponent {
  render() {
    return `
    <style>
        .results-banner {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            align-content: center;
            text-align: center;
            background-color: #F1F9F7;
            padding: 32px 20px 20px;
        }
    </style>
    <div class="results-banner">
        <slot></slot>
    </div>
    `;
  }
}
